// Проверка на мобильное устройство
export function getModalDevise ()
{
    let modalDevise = false;

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        modalDevise = true
    }

    return modalDevise;
}

// адаптация блоков под мобилу
export function adaptationBlocksMobile (visual)
{
    if (getModalDevise()) {
        fullWidthBlock(visual);
        gtiListToursCustom(visual);
        gtiFreeConsultationCustom(visual);
    }
}

/*export function formControlInput(form) {
    const control = BX(form).querySelectorAll('.js_control');

    control.forEach((div) => {
        div.addEventListener('click', BX.delegate(formClickInput, this));
    })
}*/

// Перемещаем ссылку в верхнюю часть блока
export function setWidthSpan (orientation, width, visual)
{
    // console.log("orientation => ", orientation)
    // console.log("devise =>", devise)
    // console.log("width =>", width)

    const listTours = BX(visual.LIST_TOURS_ID);
    // const listToursCont = listTours.querySelector('.list_tours_cont')
    // listToursCont.classList.add('mobail');


    if (width <= 700 && width >= 451) {
        const spanLinkDetail = listTours.querySelectorAll('span.ltc_link_detail');
        spanLinkDetail.forEach((ltLink) => {
            const closestLinks = ltLink.closest('.ltc_linc_cont');
            const ltLinksNode = ltLink.cloneNode(true);
            ltLinksNode.classList.add('top');
            ltLink.remove();
            closestLinks.insertAdjacentElement("beforebegin", ltLinksNode);
        })
    }

    if (width <= 450) {
        const ltcLincCont = listTours.querySelectorAll('.ltc_linc_cont');
        ltcLincCont.forEach((ltLink) => {
            const spanLinkDetail = ltLink.querySelector('span.ltc_link_detail');
            const ltLinksNode = spanLinkDetail.cloneNode(true);
            ltLinksNode.classList.add('bottom');
            spanLinkDetail.remove();

            const numberWeekMonth = ltLink.querySelector('.number_week_month');
            const numberWeekMonthNode = numberWeekMonth.cloneNode(true);
            numberWeekMonth.remove();

            const ltcLeftCont = ltLink.querySelector('.ltc_left_cont');
            ltcLeftCont.insertAdjacentElement("beforeend", numberWeekMonthNode);

            const ltcrFlex = ltLink.querySelector('.ltcr_flex');
            ltcrFlex.insertAdjacentElement("afterbegin", ltLinksNode);
        })
    }

}



// удаляем label в форме
/*function formClickInput(e) {
    const div = e.target.parentElement;
    const label = div.querySelector('label');

    label.innerText = '';
}*/

// Делаем блоки на всю ширину
function fullWidthBlock (visual)
{
    const excursionTours = BX(visual.GROUP_EXCURSION_TOURS_ID);
    const listTours = BX(visual.LIST_TOURS_ID);

    const containerExcursionTours = excursionTours.querySelector('.container');
    const containerListTours = listTours.querySelector('.container');

    containerExcursionTours.classList.remove('container');
    containerListTours.classList.remove('container');
}

// Изменяем блоки в gti_list_tours
function gtiListToursCustom(visual)
{
    /*const listTours = BX(visual.LIST_TOURS_ID);
    const listToursCont = listTours.querySelector('.list_tours_cont')

    listToursCont.classList.add('mobail');

    const spanLinkDetail = listTours.querySelectorAll('span.ltc_link_detail');
    spanLinkDetail.forEach((ltLink) => {
        const closestLinks = ltLink.closest('.ltc_linc_cont');
        const ltLinksNode = ltLink.cloneNode(true);
        ltLink.remove();
        closestLinks.insertAdjacentElement("beforebegin", ltLinksNode);
    })*/




    /*const listTours = BX(visual.LIST_TOURS_ID);
    const ltLinks = listTours.querySelectorAll('.list_tours_link_detail');
    ltLinks.forEach((ltLink) => {
        const listToursItem = ltLink.closest('.list_tours_item');

        const ltLinkNode = ltLink.cloneNode(true);
        ltLink.remove();
        listToursItem.insertAdjacentElement("beforeend", ltLinkNode);
    })*/


}

// Изменяем блок gti_free_consultation
function gtiFreeConsultationCustom(visual) {
    const freeConsultation = BX(visual.FREE_CONSULTATION_ID);
    const container = freeConsultation.querySelector('.container');
    const imgBlock = freeConsultation.querySelector('.bg_free_consultation');
    const form = freeConsultation.querySelector('.fc_form_cont');
    const leftCont = freeConsultation.querySelector('.left_cont');
    const rightCont = freeConsultation.querySelector('.right_cont');

    container.classList.remove('container');
    leftCont.classList.add('container')

    const formNode = form.cloneNode(true);
    const imgBlockNode = imgBlock.cloneNode(true);

    form.remove();
    imgBlock.remove();

    leftCont.insertAdjacentElement("beforeend", formNode);
    rightCont.insertAdjacentElement("afterbegin", imgBlockNode);
}


